<div class="link-table mb-3">
	<div class="row link-header">
		<div class="col-xs-auto bg-dark header-icon">
			<span class="material-icons">settings</span>
		</div>
		<div class="col align-self-center">
			<span class="title">{{title}}</span>
		</div>
	</div>

	<app-loader-wrapper [loading]="!links" size="sm" class="link-body">
		<ng-container *ngIf="links">
			<div
				class="row align-items-center mx-0 p-1 bordered-top link"
				*ngFor="let link of links"
			>
				<div class="col-12">
					<a [routerLink]="link.url" title="{{link.title}}">{{link.name}}</a>
				</div>
			</div>
		</ng-container>
	</app-loader-wrapper>
</div>
